import { Box, Paper } from "@mui/material";

export default function Card2({ title, style = {}, children }) {
  return (
    <Box className="my-card" sx={{ padding: "2%", width: "100%", ...style }}>
      {children}
      <h5 style={{ color: "rgb(124, 124, 124)", marginTop: "-12px" }}>
        {title}
      </h5>
    </Box>
  );
}
